import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutRightFull: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-right-full, grid, window"><path d="M20.25 3.75H21V3L20.25 3V3.75ZM3.75 3.75L3.75 3L3 3L3 3.75L3.75 3.75ZM3.75 20.25H3L3 21H3.75V20.25ZM20.25 20.25V21H21V20.25H20.25ZM20.25 3L3.75 3L3.75 4.5L20.25 4.5V3ZM3 3.75L3 20.25H4.5L4.5 3.75L3 3.75ZM3.75 21H20.25V19.5H3.75V21ZM21 20.25V3.75H19.5V20.25H21Z" fill="currentColor"/><path d="M13.5 20.25V21H15V20.25H13.5ZM15 3.75V3H13.5V3.75H15ZM15 20.25V3.75H13.5V20.25H15Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutRightFull;
